module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.5cf5ebf.woff";